// Design registry. Each entry is a complete look — colors, fonts, radius, glow.
// Use `data-theme="<id>"` on <html> to scope rare overrides. Most theming flows
// through CSS custom properties (see lib/useTheme.js applyTheme).

export const THEMES = {
  hunter: {
    id: 'hunter',
    label: 'Hunter',
    tagline: 'Solo Leveling · arise',
    vars: {
      '--bg':           '#020812',
      '--fg':           '#e6f1ff',
      '--card-bg':      'rgba(255,255,255,0.03)',
      '--card-border':  'rgba(255,255,255,0.10)',
      '--accent':       '#00f5ff',
      '--accent-fg':    '#001018',
      '--muted':        '#7c8aa3',
      '--radius':       '8px',
      '--font-display': "'Orbitron', system-ui, sans-serif",
      '--font-body':    "'Rajdhani', system-ui, sans-serif",
      '--glow':         '0 0 12px var(--accent)',
      '--shadow':       '0 4px 24px rgba(0,245,255,0.10)',
    },
    quotes: [
      'Arise.',
      'Hunters do not kneel.',
      'A weapon evolves through use.',
    ],
  },

  minimal: {
    id: 'minimal',
    label: 'Minimal',
    tagline: 'Paper · Ink · Whitespace',
    vars: {
      '--bg':           '#f7f7f5',
      '--fg':           '#1a1a1a',
      '--card-bg':      '#ffffff',
      '--card-border':  'rgba(0,0,0,0.10)',
      '--accent':       '#0a0a0a',
      '--accent-fg':    '#ffffff',
      '--muted':        '#737373',
      '--radius':       '4px',
      '--font-display': "'Inter', system-ui, sans-serif",
      '--font-body':    "'Inter', system-ui, sans-serif",
      '--glow':         'none',
      '--shadow':       '0 1px 2px rgba(0,0,0,0.04)',
    },
    quotes: [
      'Less, but better.',
      'Whitespace is information.',
      'Form follows habit.',
    ],
  },

  glass: {
    id: 'glass',
    label: 'Glass',
    tagline: 'Soft · iOS · Frosted',
    vars: {
      '--bg':           'linear-gradient(160deg, #0f172a 0%, #1e1b4b 50%, #312e81 100%)',
      '--fg':           '#f3f4f6',
      '--card-bg':      'rgba(255,255,255,0.08)',
      '--card-border':  'rgba(255,255,255,0.18)',
      '--card-blur':    'blur(16px)',
      '--accent':       '#a78bfa',
      '--accent-fg':    '#1e1b4b',
      '--muted':        '#a1a1aa',
      '--radius':       '20px',
      '--font-display': "'Inter', -apple-system, sans-serif",
      '--font-body':    "'Inter', -apple-system, sans-serif",
      '--glow':         '0 0 32px rgba(167,139,250,0.4)',
      '--shadow':       '0 8px 32px rgba(0,0,0,0.25)',
    },
    quotes: [
      'Smooth as glass.',
      'Layers of focus.',
      'Calm productivity.',
    ],
  },

  mono: {
    id: 'mono',
    label: 'Mono',
    tagline: 'Terminal · Code · Green',
    vars: {
      '--bg':           '#0c0c0c',
      '--fg':           '#d6d6d6',
      '--card-bg':      '#141414',
      '--card-border':  '#2a2a2a',
      '--accent':       '#7cffb2',
      '--accent-fg':    '#001a0a',
      '--muted':        '#6a6a6a',
      '--radius':       '2px',
      '--font-display': "'JetBrains Mono', 'Fira Code', monospace",
      '--font-body':    "'JetBrains Mono', 'Fira Code', monospace",
      '--glow':         '0 0 6px rgba(124,255,178,0.5)',
      '--shadow':       '0 0 0 1px #2a2a2a',
    },
    quotes: [
      '> arise.exe --quiet',
      'discipline.compile() ok',
      'no fluff. just reps.',
    ],
  },

  pastel: {
    id: 'pastel',
    label: 'Pastel',
    tagline: 'Warm · Soft · Friendly',
    vars: {
      '--bg':           '#fdf6f0',
      '--fg':           '#3a2a2a',
      '--card-bg':      '#ffffff',
      '--card-border':  'rgba(218,178,165,0.4)',
      '--accent':       '#e8839b',
      '--accent-fg':    '#3a1a25',
      '--muted':        '#a78a82',
      '--radius':       '14px',
      '--font-display': "'Fraunces', Georgia, serif",
      '--font-body':    "'Inter', system-ui, sans-serif",
      '--glow':         '0 4px 16px rgba(232,131,155,0.20)',
      '--shadow':       '0 2px 12px rgba(218,178,165,0.20)',
    },
    quotes: [
      'Sanft, aber konsequent.',
      'Gewohnheiten wie Tee — täglich.',
      'Klein anfangen. Groß denken.',
    ],
  },
}

export const THEME_IDS = Object.keys(THEMES)
